import React, { useState, useCallback } from "react";
import {
  Typography,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  IconButton,
  Drawer,
  Box,
  TextField,
  Grid,
  CircularProgress 
} from "@mui/material";
import PaginationComp from "../../../Pagination/PaginationComp";
import Popover from "@mui/material/Popover";
import AddToPhotosOutlinedIcon from "@mui/icons-material/AddToPhotosOutlined";

const InternationalTable = ({
  merchant,
  message,
  page,
  totalPage,
  setPage,
  ReadData,
  authRead,
  authDelete,
  authUpdate,
  loading
}) => {

  const currencyFlags = {
    ARS: "arsflag.svg",
    AZN: "aznflag.svg",
    COP: "copflag.svg",
    EGP: "egpflag.svg",
    GHC: "ghcflag.svg",
    IDR: "idrflag.svg",
    INR: "inrflag.svg",
    JPY: "jpyflag.svg",
    KZT: "kztflag.svg",
    KGS: "kgsflag.svg",
    PHP: "phpflag.svg",
    BDT: "bdtflag.svg",
    BRL: "brlflag.svg",
    CLP: "clpflag.svg",
    CNY: "cnyflag.svg",
    CRC: "crcflag.svg",
    EUR: "euroflag.svg",
    GTQ: "gtqflag.svg",
    KRW: "krwflag.svg",
    KES: "kesflag.svg",
    LAK: "lakflag.svg",
    MXN: "mxnflag.svg",
    MYR: "myrflag.svg",
    NGN: "ngnflag.svg",
    PEN: "penflag.svg",
    PKR: "pkrflag.svg",
    THB: "thbflag.svg",
    UGX: "ugxflag.svg",
    USD: "usdflag.svg",
    USDT: "usdflag.svg",
    VND: "vndflag.svg",
    ZAR: "zarflag.svg",
    PLN: "plnflag.svg",
    RUB: "rubflag.svg",
    SGD: "sgdflag.svg",
    TRY: "tryflag.svg",
    UAH: "uahflag.svg",
    GBP: "gbpflag.svg",
    UZS: "uzsflag.svg",
    BIF: "bifflag.svg",
    XAF: "xafflag.svg",
    TZSHS: "tzshsflag.svg",
    ZMW: "zmwflag.svg",
    AED: "uaeflag.svg",
    MDL: "mdlflag.svg",
    XOF: "xofflag.svg",
    RWF: "rwfflag.svg",
  };

  const getCurrencyFlag = (currencyCode) => {
    try {
      return require(`../../../assets/currencyFlags/${currencyFlags[currencyCode]}`);
    } catch (err) {
      console.error(`Error loading flag for ${currencyCode}:`, err);
      return null; 
    }
  };

  return (
    <>
      <div style={{ maxHeight: "calc(100vh - 180px)", overflowY: "auto", marginTop: "16px", position: "relative" }}>
        {loading ? (
          <Box display="flex" justifyContent="center" alignItems="center" my={3}>
            <CircularProgress sx={{color: "#ff6600"}} />
          </Box>
        ) : (
          <Table
            stickyHeader
            sx={{
              mt: 2,
              borderRadius: 2,
              backgroundColor: "#fff",
              boxShadow: "0 4px 12px rgba(0, 0, 0, 0.06)",
              "& th, & td": {
                padding: "10px 12px",
                fontSize: "13.5px",
              },
            }}
          >
            <TableHead
              sx={{
                backgroundColor: "#f1f5f9",
                position: "sticky",
                top: 0,
                zIndex: 1,
                "& th": {
                  fontWeight: 600,
                  color: "#1f2937",
                  textTransform: "uppercase",
                  fontSize: "12px",
                  borderBottom: "1px solid #e0e0e0",
                  backgroundColor: "#f1f5f9",
                  whiteSpace: 'nowrap'
                },
              }}
            >
              <TableRow>
                {[
                  "Settlement Info",
                  "From Currency",
                  "To Currency",
                  "Status",
                  "Requested Amount",
                  "Rates",
                  "Charges",
                  "Settled Amount",
                  "Created On",
                  "Updated On",
                  "Action",
                ].map((heading) => (
                  <TableCell key={heading}>
                    <Typography
                      variant="h6"
                    >
                      {heading}
                    </Typography>
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>
            <TableBody>
              {merchant.map((merchant, index) => (
                <TableRow
                  sx={{
                    backgroundColor: index % 2 === 0 ? "#ffffff" : "#f9f9f9",
                    "&:hover": {
                      backgroundColor: "#f1f1f1",
                    },
                  }}
                >
                  <TableCell>
                    <Typography
                      variant="h6"
                      sx={{
                        whiteSpace: 'nowrap'
                      }}
                    >
                      <span style={{ color: "#1eaae7"}}>SETTLEMENT ID: {merchant.settlementId}</span><br />
                      <span style={{ color: "#ff9800"}}>MERCHANT: ({merchant.user_id}) {merchant.name}</span>
                    </Typography>
                  </TableCell>
                  <TableCell>
                    <Typography
                      sx={{
                        textAlign: "center"
                      }}
                      variant="h6"
                    >
                        <img src={getCurrencyFlag(merchant.fromCurrency)} alt={merchant.fromCurrency} width="30px" /> &nbsp;&nbsp;
                      {merchant.fromCurrency}
                    </Typography>
                  </TableCell>
                  <TableCell>
                    <Typography
                      sx={{
                        textAlign: "center"
                      }}
                      variant="h6"
                    >
                        <img src={getCurrencyFlag(merchant.toCurrency)} alt={merchant.toCurrency} width="30px" /> &nbsp;&nbsp;
                      {merchant.toCurrency}
                    </Typography>
                  </TableCell>
                  <TableCell>
                    <Typography
                      sx={{
                          color: 
                            merchant.status === 0
                          ? "red"
                          : merchant.status === 1
                          ? "green"
                          : merchant.status === 2
                          ? "orange"
                          : "gray",
                          textTransform: "uppercase"
                      }}
                      variant="h6"
                    >
                      {
                        merchant.status === 0
                        ? "Failed"
                        : merchant.status === 1
                        ? "Success"
                        : merchant.status === 2
                        ? "Pending"
                        : "Waiting For Admin Approval"
                      }
                    </Typography>
                  </TableCell>
                  <TableCell>
                    <Typography
                      variant="h6"
                      style={{textAlign: "center"}}
                    >
                      {merchant.requestedAmount}
                    </Typography>
                  </TableCell>
                  <TableCell>
                    <Typography
                      variant="h6"
                      style={{textAlign: "center"}}
                    >
                      {merchant.totalCharges ? merchant.totalCharges : 0}
                    </Typography>
                  </TableCell>
                  <TableCell>
                    <Typography
                      variant="h6"
                      style={{textAlign: "center"}}
                    >
                      {merchant.exchangeRate ? merchant.exchangeRate : 0}
                    </Typography>
                  </TableCell>
                  <TableCell>
                    <Typography
                      variant="h6"
                      style={{textAlign: "center"}}
                    >
                      {merchant.exchangeRate ? (((Number(merchant.requestedAmount) - Number(merchant.totalCharges))/Number(merchant.exchangeRate)).toFixed(2)) : (Number(merchant.requestedAmount) - Number(merchant.totalCharges))}
                    </Typography>
                  </TableCell>
                  <TableCell>
                    <Typography
                      variant="h6"
                    >
                      {merchant.requested_time}
                    </Typography>
                  </TableCell>
                  <TableCell>
                    <Typography
                      variant="h6"
                    >
                      {merchant.settlement_time}
                    </Typography>
                  </TableCell>           
                  <TableCell align="center">
                    {authRead ? (
                      <ViewDrawer item={merchant} authRead={authRead} />
                    ) : null}
                  </TableCell>
                </TableRow>
              ))}
              <TableRow>
                <TableCell colSpan={12} align="center">
                  
                </TableCell>
              </TableRow>
            </TableBody>
          </Table>
        )}
      </div>
      <PaginationComp
        setPage={setPage}
        page={page}
        totalPage={totalPage}
        message={message}
        disabled={loading}
      />
    </>
  );
};

const ViewDrawer = ({ item, authRead }) => {
  const [state, setState] = useState({ right: false });

  const toggleDrawer = (open) => () => {
    setState({ right: open });
    if (open) {
        // console.log(item)
    } else {
      // window.location.reload();
    }
  };

  const statusMap = {
    0: "FAILED",
    1: "SUCCESS",
    2: "PENDING",
    3: "WAITING FOR ADMIN APPROVAL"
  };


  return (
    <div>
      {authRead && (
        <button
          className="btn btn-secondary btn-sm"
          onClick={toggleDrawer(true)}
        >
          View
        </button>
      )}
      <Drawer anchor="right" open={state.right} onClose={toggleDrawer(false)} PaperProps={{ style: { zIndex: 3 }, }}>
        <Box role="presentation" sx={{ width: {xs: 300, sm: 500} }}>
          <div style={{ padding: "20px", position: "relative" }}>
            <h4>SETTLEMENT DETAILS</h4>
            <button
              style={{
                position: "absolute",
                top: "22px",
                right: "10px",
                background: "#ff6600",
                border: "none",
                borderRadius: "50%",
                cursor: "pointer",
                padding: "5px",
                width: "25px",
                height: "25px",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
              onClick={toggleDrawer(false)}
            >
              <svg
                xmlns="http://www .org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                stroke="white"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
                className="feather feather-x"
                style={{
                  display: "block",
                  width: "100%",
                  height: "100%",
                }}
              >
                <line x1="18" y1="6" x2="6" y2="18"></line>
                <line x1="6" y1="6" x2="18" y2="18"></line>
              </svg>
            </button>
            <Grid container spacing={2}>
              {[
                { label: "SETTLEMENT ID.", value: item?.settlementId || "NOT AVAILABLE" },
                { label: "SETTLEMENT STATUS", value: statusMap[item?.status] || "NOT AVAILABLE" },
                { label: "FROM CURRENCY", value: item?.fromCurrency || "NOT AVAILABLE" },
                { label: "TO CURRENCY", value: item?.toCurrency || "NOT AVAILABLE" },
                { label: "SETTLEMENT TYPE", value: item?.settlementType || "NOT AVAILABLE" },
                { label: "WALLET ADDRESS", value: item?.walletAddress || "NOT AVAILABLE" },
                { label: "ACCOUNT NUMBER", value: item?.accountNumber || "NOT AVAILABLE" },
                { label: "BANK NAME", value: item?.bankName || "NOT AVAILABLE" },
                { label: "BRANCH NAME", value: item?.branchName || "NOT AVAILABLE" },
                { label: "CITY", value: item?.city || "NOT AVAILABLE" },
                { label: "COUNTRY", value: item?.country || "NOT AVAILABLE" },
                { label: "ZIPCODE", value: item?.zip_code || "NOT AVAILABLE" },
                { label: "SWIFT CODE", value: item?.swiftCode || "NOT AVAILABLE" },
                { label: "REQUESTED AMOUNT", value: item?.requestedAmount || "NOT AVAILABLE" },
                { label: "CHARGES", value: item?.totalCharges || 0 },
                { label: "EXCHANGE RATE", value: item?.exchangeRate || 0 },
                { label: "NET SETTLEMENT", value: item?.exchangeRate ? parseFloat((Number(item?.requestedAmount) - Number(item?.totalCharges))/Number(item?.exchangeRate)).toFixed(2) : Number(item?.requestedAmount) - Number(item?.totalCharges)  || "NOT AVAILABLE" },
                { label: "REQUESTED DATE", value: item?.requested_time || "NOT AVAILABLE" },
                { label: "SETTLEMENT DATE", value: item?.settlement_time || "NOT AVAILABLE" },
              ].map((field, index) => (
                <Grid item xs={12} sm={6} key={index}>
                  <TextField
                    label={field.label}
                    variant="outlined"
                    fullWidth
                    margin="normal"
                    value={field.value}
                    InputProps={{ readOnly: true, style: { zIndex: 4} }}
                    disabled
                  />
                </Grid>
              ))}
            </Grid>

          </div>
        </Box>
      </Drawer>
    </div>
  );
};

export default InternationalTable;